import { render, staticRenderFns } from "./inventorylist.vue?vue&type=template&id=7b8aab86&scoped=true&"
import script from "./inventorylist.vue?vue&type=script&lang=js&"
export * from "./inventorylist.vue?vue&type=script&lang=js&"
import style0 from "./inventorylist.vue?vue&type=style&index=0&id=7b8aab86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8aab86",
  null
  
)

export default component.exports